<div class="slider">
  <p-carousel
    [value]="sliderImages"
    styleClass="custom-carousel"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="true">
    <ng-template let-slide pTemplate="item">
        <div (click)="goToPopular()" style="cursor: pointer;">
          <img src="{{slide.slideSrc}}" alt="slide">
        </div>
    </ng-template>
  </p-carousel>
</div>
